import { render, staticRenderFns } from "./RemoteOpen.vue?vue&type=template&id=38828276&scoped=true"
import script from "./RemoteOpen.vue?vue&type=script&lang=js"
export * from "./RemoteOpen.vue?vue&type=script&lang=js"
import style0 from "./RemoteOpen.vue?vue&type=style&index=0&id=38828276&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38828276",
  null
  
)

export default component.exports